import React from 'react';
import {EfeSpinner} from 'components';

function useSpinner(open: boolean, message = 'loading...') {
    return <EfeSpinner message={message} open={open} />;
}

export default useSpinner;
